import CallFiltersViewModel from "../Filtering/ReworkedFilters/CallFilters/ViewModels/CallFiltersViewModel";
import ComplaintsFiltersViewModel from "../Filtering/ReworkedFilters/ComplaintsFilters/ViewModels/ComplaintsFiltersViewModel";
import DateTimeFiltersViewModel from "../Filtering/ReworkedFilters/DateTimeFilters/ViewModels/DateTimeFiltersViewModel";
import OperationsFiltersViewModel from "../Filtering/ReworkedFilters/OperationsFilters/ViewModels/OperationsFiltersViewModel";
import QaFiltersViewModel from "../Filtering/ReworkedFilters/QaFilters/ViewModels/QaFiltersViewModel";
import ReportCodeFiltersViewModel from "../Filtering/ReworkedFilters/ReportCodeFilters/ViewModels/ReportCodeFiltersViewModel";
import SalesFiltersViewModel from "../Filtering/ReworkedFilters/SalesFilters/ViewModels/SalesFiltersViewModel"
import TranscriptFiltersViewModel from "../Filtering/ReworkedFilters/TranscriptFilters/ViewModels/TranscriptFiltersViewModel";
import VulnerabilitiesFiltersViewModel from "../Filtering/ReworkedFilters/VulnerabilitiesFilters/ViewModels/VulnerabilitiesFiltersViewModel";
import SentimentFiltersViewModel from "../Filtering/ReworkedFilters/SentimentFilters/ViewModels/SentimentFiltersViewModel";
import AdvancedFiltersViewModel from "../Filtering/ReworkedFilters/AdvancedFilters/Viewmodels/AdvancedFiltersViewModel";
import SalesAIAnswerViewModel from "../Filtering/ReworkedFilters/SalesAIFilters/ViewModels/SalesAIAnswerViewModel";
import ScorecardAnswersViewModel from "../Filtering/ReworkedFilters/ScorecardAnswerFilters/ViewModels/ScorecardAnswersViewModel";
import QAScorecardFilterViewModel from "../Filtering/ReworkedFilters/QAScorecardFilter/ViewModels/QAScorecardFilterViewModel";
import AIFlaggedIssueViewModel from "../Filtering/ReworkedFilters/AIFlaggedIssuesFilters/ViewModels/AIFlaggedIssueViewModel";
import CustomerFiltersViewModel from "../Filtering/ReworkedFilters/CustomerFilter/ViewModels/CustomerFilterViewModel";
import { ColumnViewModel } from "../Filtering/DisplayComponents/ViewModels/ColumnViewModel";
import GdprFiltersViewModel from "../Filtering/ReworkedFilters/VoiceOfTheCustomerFilter/ViewModel/GDPRFiltersViewModel";
import VOCFiltersViewModel from "../Filtering/ReworkedFilters/VoiceOfTheCustomerFilter/ViewModel/VOCFiltersViewModel";
import QAComplaintsFiltersViewModel from "../Filtering/ReworkedFilters/ComplaintsFilters/ViewModels/QAComplaintsFiltersViewModel";
import AINoteFiltersViewModel from "../Filtering/ReworkedFilters/AINoteFilters/ViewModels/AINoteFiltersViewModel";
import InsightAnswerViewModel from "../Filtering/ReworkedFilters/InsightFilters/ViewModels/InsightAnswerViewModel";
import CustomerSentimentFiltersViewModel from "../Filtering/ReworkedFilters/SentimentFilters/ViewModels/CustomerSentimentFiltersViewModel";
import CXAIFiltersViewModel from "../Filtering/ReworkedFilters/CXAIFilters/ViewModels/CXAIFiltersViewModel";


export default class CallTableViewModel {
    filters: CallTableFilters = new CallTableFilters();
    columns: CallTableColumns = new CallTableColumns();

    constructor(client?: string) {
        this.filters = new CallTableFilters(client)
    }
}

export const orderByOptions = [
    { value: "EventTimeDesc", label: "Event Time (Descending)" },
    { value: "EventTimeAsc", label: "Event Time (Ascending)" },
    { value: "CallLengthDesc", label: "Call Length (Descending)" },
    { value: "CallLengthAsc", label: "Call Length (Ascending)" },
];

//set the model's isActive to true here if you want them to be defaulted on the filter bar
export class CallTableFilters {
    dateTimeFilters: DateTimeFiltersViewModel = new DateTimeFiltersViewModel();
    salesFilters: SalesFiltersViewModel = new SalesFiltersViewModel()
    qaFilters: QaFiltersViewModel = new QaFiltersViewModel();
    operationsFilters: OperationsFiltersViewModel = new OperationsFiltersViewModel();
    vulnerabilitiesFilters: VulnerabilitiesFiltersViewModel = new VulnerabilitiesFiltersViewModel();
    complaintsFilters: ComplaintsFiltersViewModel = new ComplaintsFiltersViewModel();
    reportCodeFilters: ReportCodeFiltersViewModel = new ReportCodeFiltersViewModel();
    callFilters: CallFiltersViewModel = new CallFiltersViewModel();
    customerSentimentFilters: CustomerSentimentFiltersViewModel = new CustomerSentimentFiltersViewModel();
    agentSentimentFilters: SentimentFiltersViewModel = new SentimentFiltersViewModel();
    transcriptFilters: TranscriptFiltersViewModel = new TranscriptFiltersViewModel();
    advancedFilters: AdvancedFiltersViewModel = new AdvancedFiltersViewModel();
    customerFilters: CustomerFiltersViewModel = new CustomerFiltersViewModel();
    salesAI: SalesAIAnswerViewModel = new SalesAIAnswerViewModel();
    cxaiFilters: CXAIFiltersViewModel = new CXAIFiltersViewModel();
    insight: InsightAnswerViewModel = new InsightAnswerViewModel();
    aiFlaggedIssues: AIFlaggedIssueViewModel = new AIFlaggedIssueViewModel();
    scorecardAnswer: ScorecardAnswersViewModel = new ScorecardAnswersViewModel();
    qaScorecardFilter: QAScorecardFilterViewModel = new QAScorecardFilterViewModel();
    gdprFilters: GdprFiltersViewModel = new GdprFiltersViewModel();
    qaComplaintsFilters: QAComplaintsFiltersViewModel = new QAComplaintsFiltersViewModel();
    aiNoteFilters: AINoteFiltersViewModel = new AINoteFiltersViewModel();
    orderBy: string = orderByOptions[0].value;
    client: string = '';
    vocFilters: VOCFiltersViewModel = new VOCFiltersViewModel();
    pageNumber: number = 1;
    pageCount: number;
    rowsPerPage: number;
    count: number;

    constructor(client?: string) {
        this.client = client ?? ''
    }
}

//set isActive to true here if you want them to be defaulted on the filter bar
export class CallTableColumns {

    public setShownStateByMode(mode: string, isClientScorecardEnabled: boolean = false, isOperationsScorecardEnabled: boolean = false) {
        switch (mode) {
            case "Admin":
                this.setModeToAdmin();
                break;
            case "Exec":
                this.setModeToExec();
            case "TeamLeader":
                this.setModeToTeamLeader(isOperationsScorecardEnabled);
                break;
            case "Agent":
                this.setModeToAgent();
                break;
            case "ClientAI":
                this.setModeToAI();
                break;
            case "Client":
                this.setModeToClient(isClientScorecardEnabled);
                break;
            case "RTM":
                this.setModeToRTM();
                break;
            case "QA":
                this.setModeToQA();
                break;
            case "Dialler":
                this.setModeToDialler();
                break;
            default:
                throw new Error(`This User Dosen't Have Any Of The Expected Permissions : ${mode}`)
            //break;
        }
    }

    //#region Hide and disable values based on user mode
    private setModeToAdmin() {
        this.outcomeFilters.isHidden = true;
    }

    private setModeToExec() {
        this.setModeToAdmin();
    }

    private setModeToTeamLeader(isOperationsScorecardEnabled: boolean = false) {
        //this may be needed in the latest version
        this.outcomeFilters.isActive = false;
        this.outcomeFilters.isHidden = true;

        if (isOperationsScorecardEnabled) {
            this.scoreFilter.isActive = true;
            this.scoreFilter.isHidden = false;
        } else {
            this.scoreFilter.isActive = false;
            this.scoreFilter.isHidden = true;
        }
    }

    private setModeToAgent() {
        this.customerIDFilter.isHidden = true;
        this.phoneNumberFilter.isHidden = true;
        this.agentNameFilter.isHidden = true;

        //#region temp
        this.agentNameFilter.isActive = false;
        this.agentNameFilter.isHidden = true;

        this.channelFilter.isActive = false;
        this.channelFilter.isHidden = true;

        this.clientFilter.isActive = false;
        this.clientFilter.isHidden = true;

        this.eventTimeFilter.isActive = false;
        this.eventTimeFilter.isHidden = true;

        this.callReasonFilter.isActive = false;
        this.callReasonFilter.isHidden = true;

        this.callCategoryFilter.isActive = false;
        this.callCategoryFilter.isHidden = true;

        this.typeFilter.isActive = false;
        this.typeFilter.isHidden = true;

        this.teamLeaderFilter.isActive = false;
        this.teamLeaderFilter.isHidden = true;

        this.teamFilter.isActive = false;
        this.teamFilter.isHidden = true;

        this.reportCode1Filter.isActive = false;
        this.reportCode1Filter.isHidden = true;

        this.reportCode1DescriptionFilter.isActive = false;
        this.reportCode1DescriptionFilter.isHidden = true;

        this.reportCode3Filter.isActive = false;
        this.reportCode3Filter.isHidden = true;

        this.reportCode3DescriptionFilter.isActive = false;
        this.reportCode3DescriptionFilter.isHidden = true;

        this.siteFilter.isActive = false;
        this.siteFilter.isHidden = true;

        this.systemIDFilter.isActive = false;
        this.systemIDFilter.isHidden = true;

        this.payrollNumberFilter.isActive = false;
        this.payrollNumberFilter.isHidden = true;

        this.platformFilter.isActive = false;
        this.platformFilter.isHidden = true;

        this.complaintFilter.isActive = false;
        this.complaintFilter.isHidden = true;

        this.complaintCategoryFilter.isActive = false;
        this.complaintCategoryFilter.isHidden = true;

        this.vulnerabilityFilter.isActive = false;
        this.vulnerabilityFilter.isHidden = true;

        this.vulnerabilityCategoryFilter.isActive = false;
        this.vulnerabilityCategoryFilter.isHidden = true;

        this.saleTypeFilter.isActive = false;
        this.saleTypeFilter.isHidden = true;

        this.productFilter.isActive = false;
        this.productFilter.isHidden = true;

        this.productTypeFilter.isActive = false;
        this.productTypeFilter.isHidden = true;

        this.productOfferFilter.isActive = false;
        this.productOfferFilter.isHidden = true;

        this.clientReferenceFilter.isActive = false;
        this.clientReferenceFilter.isHidden = true;

        this.themeFilter.isActive = false;
        this.themeFilter.isHidden = true;

        this.outcomeFilters.isActive = false;
        this.outcomeFilters.isHidden = true;
        //#endregion
    }

    private setModeToAI() {
        this.sentimentFilter.isActive = false;
        this.sentimentFilter.isHidden = true;

        this.complaintFilter.isActive = false;
        this.complaintFilter.isHidden = true;

        this.complaintCategoryFilter.isActive = false;
        this.complaintCategoryFilter.isHidden = true;

        this.vulnerabilityFilter.isActive = false;
        this.vulnerabilityFilter.isHidden = true;

        this.vulnerabilityCategoryFilter.isActive = false;
        this.vulnerabilityCategoryFilter.isHidden = true;

        this.scoreFilter.isActive = false;
        this.scoreFilter.isHidden = true;

        this.originatorFilters.isActive = false;
        this.originatorFilters.isHidden = true;

        this.outcomeFilters.isActive = false;
        this.outcomeFilters.isHidden = true;
    }

    private setModeToQA() {
        this.originatorFilters.isHidden = true;
        this.outcomeFilters.isHidden = true;
    }

    private setModeToClient(isClientScorecardEnabled: boolean = false) {
        this.sentimentFilter.isActive = false;
        this.sentimentFilter.isHidden = true;

        this.complaintFilter.isActive = false;
        this.complaintFilter.isHidden = true;

        this.complaintCategoryFilter.isActive = false;
        this.complaintCategoryFilter.isHidden = true;

        this.vulnerabilityFilter.isActive = false;
        this.vulnerabilityFilter.isHidden = true;

        this.vulnerabilityCategoryFilter.isActive = false;
        this.vulnerabilityCategoryFilter.isHidden = true;

        if (isClientScorecardEnabled) {
            this.scoreFilter.isActive = true;
            this.scoreFilter.isHidden = false;
        } else {
            this.scoreFilter.isActive = false;
            this.scoreFilter.isHidden = true;
        }

        this.themeFilter.isActive = false;
        this.themeFilter.isHidden = true;

        this.originatorFilters.isActive = false;
        this.originatorFilters.isHidden = true;

        this.outcomeFilters.isActive = false;
        this.outcomeFilters.isHidden = true;
    }

    private setModeToRTM() {
        //this may be needed in the latest version
        this.originatorFilters.isActive = false;
        this.originatorFilters.isHidden = true;

        this.outcomeFilters.isActive = false;
        this.outcomeFilters.isHidden = true;
    }

    private setModeToDialler() {
        this.outcomeFilters.isActive = false;
        this.outcomeFilters.isHidden = true;
    }
    //#endregion

    agentNameFilter = new ColumnViewModel("Agent Name", true, false);
    channelFilter = new ColumnViewModel("Channel", true, false);
    clientFilter = new ColumnViewModel("Client", false, false);
    customerIDFilter = new ColumnViewModel("Customer ID", true, false);
    eventTimeFilter = new ColumnViewModel("Event Time", true, false);
    phoneNumberFilter = new ColumnViewModel("Phone Number", true, false);
    callLengthFilter = new ColumnViewModel("Call Length", true, false);
    callReasonFilter = new ColumnViewModel("Call Reason", false, false);
    callCategoryFilter = new ColumnViewModel("Call Category", false, false);
    resultFilter = new ColumnViewModel("Result", true, false);
    typeFilter = new ColumnViewModel("Type", true, false);
    sentimentFilter = new ColumnViewModel("Sentiment", true, false);
    teamLeaderFilter = new ColumnViewModel("Team Leader", false, false);
    teamFilter = new ColumnViewModel("Team", false, false);
    reportCode1Filter = new ColumnViewModel("Report Code 1", false, false);
    reportCode1DescriptionFilter = new ColumnViewModel("Report Code 1 Description", false, false);
    reportCode3Filter = new ColumnViewModel("Report Code 3", false, false);
    reportCode3DescriptionFilter = new ColumnViewModel("Report Code 3 Description", false, false);
    siteFilter = new ColumnViewModel("Site", false, false);
    systemIDFilter = new ColumnViewModel("System ID", false, false);
    payrollNumberFilter = new ColumnViewModel("Payroll Number", false, false);
    platformFilter = new ColumnViewModel("Platform", false, false);
    complaintFilter = new ColumnViewModel("Complaint", false, false);
    complaintCategoryFilter = new ColumnViewModel("Complaint Category", false, false);
    vulnerabilityFilter = new ColumnViewModel("Vulnerability", false, false);
    vulnerabilityCategoryFilter = new ColumnViewModel("Vulnerability Category", false, false);
    saleTypeFilter = new ColumnViewModel("Sale Type", false, false);
    productFilter = new ColumnViewModel("Product", false, false);
    productTypeFilter = new ColumnViewModel("Product Type", false, false);
    productOfferFilter = new ColumnViewModel("Product Offer", false, false);
    scoreFilter = new ColumnViewModel("QA Score", true, false);
    clientReferenceFilter = new ColumnViewModel("Client Reference", false, false);
    themeFilter = new ColumnViewModel("Theme", false, false);
    originatorFilters = new ColumnViewModel("Originator", false, true);
    outcomeFilters = new ColumnViewModel("Outcome", false, true);
}
